import { Link } from "react-router-dom";
import { Panel, StatusPill, DeptTag } from "@/components/mh/bits";

export const AgentRow = ({ a, dept, i = 0 }) => (
  <Link to={`/atlas/${a.slug}`} data-testid={`agent-row-${a.slug}`} className={`block mh-rise ${a.tailored && !a.tailored.enabled ? "opacity-45" : ""}`} style={{ animationDelay: `${Math.min(i, 20) * 25}ms` }}>
    <Panel cls="p-4 h-full transition-[border-color,background-color] duration-200 hover:border-white/20 hover:bg-white/[0.03]">
      <div className="flex items-center justify-between gap-2">
        {dept ? <DeptTag name={dept.name} hex={dept.hex} /> : <span className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">{a.stage}</span>}
        <StatusPill status={a.runtime?.status} />
      </div>
      <div className="font-medium mt-2.5">{a.name}</div>
      <p className="text-sm text-muted-foreground mt-1 line-clamp-2">{a.one_liner}</p>
      <div className="flex flex-wrap gap-1.5 mt-3 font-mono text-[10px] text-muted-foreground">
        <span className="px-1.5 py-0.5 rounded border border-white/10">{a.stage}</span>
        <span className="px-1.5 py-0.5 rounded border border-white/10">{a.autonomy}</span>
        <span className="px-1.5 py-0.5 rounded border border-white/10">risk {a.risk_level}</span>
        {a.tailored && <span className="px-1.5 py-0.5 rounded border border-[#D4FF3A]/40 text-[#D4FF3A]" data-testid={`agent-tailored-${a.slug}`}>{a.tailored.enabled ? `tailored${a.tailored.value?.money_high ? ` · ≤${Math.round(a.tailored.value.money_high)}/mo` : ""}` : "off for you"}</span>}
        {a.runtime?.status === "live" && <span className="px-1.5 py-0.5 rounded border border-white/10 text-foreground">{a.runtime.runs_today} runs</span>}
      </div>
    </Panel>
  </Link>
);
